import {Router} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import {map, Observable} from 'rxjs';
import {UserSessionService} from '../services/user-session-service/user-session.service';

@Injectable({providedIn: 'root'})
export class IsNotLoggedInGuard {
  private readonly userSessionService = inject(UserSessionService);
  private readonly router = inject(Router);


  public canActivate(): Observable<boolean> {
    return this.userSessionService.waitForSession().pipe(
      map(user => {
        if (user != null) {
          this.router.navigate(['/']).then();
          return false;
        }
        return true;
      })
    );
  }
}
